import React from "react";
import {
  AppBar
} from "@mui/material";
import { AuthProps } from '../../../Services/AuthService';
import { AppState } from '../../../Store/rootReducer';
import AppContainer from '../../Controls/Layout/AppContainer/AppContainer';
import Header from '../../Controls/Layout/Header/Header';
import LoadingIndicator from "../../Shared/LoadingIndicator/LoadingIndicator";
import styles from './_home.module.scss';
import { useSelector } from "react-redux";
import DefaultAppContainer from "../../Shared/DefaultAppContainer/DefaultAppContainer";


export default function Home(props: AuthProps) {
  
  const loading = useSelector((state: AppState) => state.shared.initializingApplication);
  const currentUser = useSelector((state: AppState) => state.shared.currentUser);
  
  return loading ? <LoadingIndicator label="loading..."/> : (
    <>
      {currentUser && (
      //   <DefaultAppContainer
      //     authService={props.authService}
          
      //   //   headerContent={
      //   //   <Header
      //   //     onSignIn={props.authService?.SignIn}
      //   //     onSignOut={props.authService?.SignOut}           
      //   //     currentUser={currentUser}
      //   //   />
      //   // }
      // >
      //   <>
          <div className={styles.homeContainer}>
            <div className={styles.menus}>
              <AppBar position="relative" color="default">
                {/* <span>TODO</span> */}
              </AppBar>              
            </div>
            <span>HOME PAGE</span>
           </div>
        // </>
      // </DefaultAppContainer>          
      )}
    </>
    );
}